<template>
  <ul class="tab-menu">
    <li
      v-for="(tab, index) in tabs[currentTab]"
      v-show="currentTab == 0 ? roleTab[index][0] : currentTab == 1 ? groupTab[index][0] : currentTab == 2 ? dlplTab[index][0] :  currentTab == 3 ? tdulTab[index][0] : currentTab == 4 ? statiTab[index][0] : currentTab == 5 ? monitorTab[index][0] : statiTab[index][0]"
      v-bind:class="{ active: currentTab2 === index }"
      :key="'tabs2_' + index"
    >
      <button type="button" @click="changeTab(index, $event)">
        {{ tab }}
      </button>
    </li>
  </ul>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
  props: ["currentTab", "currentTab2"],
  data() {
    return {
      tabs: [
        [this.$i18nUtil.trans("message.AuditSubTab.001","권한설정"), this.$i18nUtil.trans("message.AuditSubTab.002","권한그룹별사용자설정"), this.$i18nUtil.trans("message.AuditSubTab.003","사용자관리")],
        [this.$i18nUtil.trans("title.ProAndPrivateList.001","과제/개인공간"), this.$i18nUtil.trans("message.AuditSubTab.004","정보 공유"), this.$i18nUtil.trans("message.AuditSubTab.005","회의협의체")],
        [this.$i18nUtil.trans("message.AuditSubTab.006","개인정보차단목록"), this.$i18nUtil.trans("message.AuditSubTab.007","파일다운로드이력"), this.$i18nUtil.trans("message.AuditSubTab.008","파일복사이력"), this.$i18nUtil.trans("message.AuditSubTab.009","로그인이력")],
        [this.$i18nUtil.trans("message.AuditSubTab.010","팀별사용자목록관리"), this.$i18nUtil.trans("message.AuditSubTab.011","코드관리"), this.$i18nUtil.trans("message.AuditSubTab.012","정보차단벽정책"), "정보차단벽예외처리", this.$i18nUtil.trans("message.AuditSubTab.013","해시코드관리"), "배치관리" ],
        [this.$i18nUtil.trans("message.AuditSubTab.014","데이터 현황")],
        [this.$i18nUtil.trans("message.AuditSubTab.016","사용자 별"), this.$i18nUtil.trans("message.AuditSubTab.015","메뉴 별"), this.$i18nUtil.trans("message.AuditSubTab.017","과제 별"), this.$i18nUtil.trans("message.AuditSubTab.018","할일 별"), this.$i18nUtil.trans("message.AuditSubTab.019","협업 사용현황 별")]
      ],
      tabFuncId: [
        "SYS_ROLE_MANAGE", "SYS_ROLE_MANAGE", "SYS_USER_MANAGE",
        "SYS_GROUP_MANAGE", "SYS_SHAR_MANAGE", "SYS_CFRC_MANAGE",
        "SYS_DLPL_VIEW", "SYS_FDLG_VIEW", "SYS_FCLG_VIEW", "SYS_LGLG_VIEW", 
        "SYS_TDUL_MANAGE", "SYS_CODE_MANAGE", "SYS_CWPO_MANAGE", "SYS_HTAG_MANAGE", "SYS_BATC_MANAGE",
        "SYS_USST_VIEW","SYS_STAT_TODO","SYS_STAT_COWORK"
      ],
      roleTab: [
        [],[],[]
      ],
      groupTab: [
        [],[],[]
      ],
      dlplTab: [
        [],[],[],[]
      ],
      tdulTab: [
        [],[],[],[],[],[]
      ],
      statiTab: [
        []
      ],
      monitorTab: [
        [], [], [], [], []
      ],
      tab5Func: ["SYS_STAT_OBJECT", "SYS_STAT_USER", "SYS_STAT_PROJECT", "SYS_STAT_TODO", "SYS_STAT_COWORK"],
      roleTypeUser: false,
    };
  },
  created() {
    this.menuCheck();
  },
  // mounted(){ 
    /* 태그사용여부에 따라 해시코드관리 탭 숨김.   */
    // if(localStorage.getItem("boardHashTagUse") == "false"){
    //   let tabMenu = document.getElementById("tabMenu2");
    //   tabMenu.style.display = "none";
    // }
  // },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 팀장 권한 확인
    checkRoleTypeUser() {
        let obj = this;
        let reqData = {};
        reqData.params = {
            roleType: "TLD",
        };
        reqData.url = "/api/org/checkRoleTypeUser";
        reqData.method = "post";            
        
        obj.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {
            obj.roleTypeUser = res.result;
            if(obj.roleTypeUser){
              obj.checkRoleUserFnc("SYS_DLPL_VIEW");
            } else {
              obj.menuCheck();
            }
        })
        .catch(function(err) {
            console.log(err);
        });
    }, */
    menuCheck(){
      if(this.currentTab == 5) {
        // 활동 현황 탭
        for(let index in this.tab5Func){
          this.checkRoleUserFnc(this.tab5Func[index]);
        }
      }else{
        for(let index in this.tabFuncId){
          this.checkRoleUserFnc(this.tabFuncId[index]);
        }
      }
    },
    checkRoleUserFnc(id){
      let obj = this;
      let reqData = {
        url : "/api/org/checkRoleUserFnc",
        method : "post",
        params : {
          funcId : id
        }
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if (res != null) {
          switch (id) {
            case "SYS_ROLE_MANAGE":
              if(obj.roleTab[0][0] == null || obj.roleTab[1][0] == null){
                obj.roleTab[0].push(res.result);
                obj.roleTab[1].push(res.result);
              }
              break;
            case "SYS_USER_MANAGE":
              obj.roleTab[2].push(res.result);
              break;
            case "SYS_GROUP_MANAGE":
              obj.groupTab[0].push(res.result);
              break;
            case "SYS_SHAR_MANAGE":
              obj.groupTab[1].push(res.result);
              break;
            case "SYS_CFRC_MANAGE":
              obj.groupTab[2].push(res.result);
              break;
            case "SYS_DLPL_VIEW":
              obj.dlplTab[0].push(res.result);
              break;
            case "SYS_FDLG_VIEW":
              obj.dlplTab[1].push(res.result);
              break;
            case "SYS_FCLG_VIEW":
              obj.dlplTab[2].push(res.result);
              break;
            case "SYS_LGLG_VIEW":
              obj.dlplTab[3].push(res.result);
              break;
            case "SYS_TDUL_MANAGE":
              obj.tdulTab[0].push(res.result);
              break;
            case "SYS_CODE_MANAGE":
              obj.tdulTab[1].push(res.result);
              break;
            case "SYS_CWPO_MANAGE":
              obj.tdulTab[2].push(res.result);
              obj.tdulTab[3].push(res.result);
              break; 
            case "SYS_HTAG_MANAGE":
              obj.tdulTab[4].push(res.result);
              break
            case "SYS_BATC_MANAGE":
              obj.tdulTab[5].push(res.result);
              break
            case "SYS_USST_VIEW":
              obj.statiTab[0].push(res.result);
              break
            case "SYS_STAT_USER":
              obj.monitorTab[0].push(res.result);
              break;
            case "SYS_STAT_OBJECT":
              obj.monitorTab[1].push(res.result);
              break;
            case "SYS_STAT_PROJECT":
              obj.monitorTab[2].push(res.result);
              break;
            case "SYS_STAT_TODO":
              obj.monitorTab[3].push(res.result);
              break;     
            case "SYS_STAT_COWORK":
            obj.monitorTab[4].push(res.result);
            break;         
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    changeTab(index, e) {
      if ($(e.target.parentElement).hasClass("active")) {
        return;
      }
      if (this.currentTab == 0) {
        if (index == 0) {
          this.$router.replace("/cosys/getRoleList");
        } else if (index == 1) {
          this.$router.replace("/cosys/getRoleUserList");
        } else if (index == 2) {
          this.$router.replace("/cosys/getUserList");
        }
      } else if (this.currentTab == 1) {
        if (index == 0) {
          this.$router.replace("/cosys/proAndPrivateList");
        } else if (index == 1) {
          this.$router.replace("/cosys/shareInfoSiteList");
        } else if (index == 2) {
          this.$router.replace("/cosys/cfrcSiteList");
        }
      } else if (this.currentTab == 2) {
        if (index == 0) {
          this.$router.replace("/cosys/fileDlpBlock");
        } else if (index == 1) {
          this.$router.replace("/cosys/fileDownload");
        } else if (index == 2) {
          this.$router.replace("/cosys/fileCopy");
        } else if (index == 3) {
          this.$router.replace("/cosys/loginLog");
        }
      } else if (this.currentTab == 3) {
        if (index == 0) {
          this.$router.replace("/cosys/getTdulList");
        } else if (index == 1) {
          this.$router.replace("/cosys/getCodeList");
        } else if (index == 2) {
          this.$router.replace("/cosys/getCwpoList");
        } else if (index == 3) {
          this.$router.replace("/cosys/cwExcept");
        } else if (index == 4) {
          this.$router.replace("/cosys/getHtagList");
        } else if (index == 5) {
          this.$router.replace("/cosys/getBatchList");
        }
      } else if (this.currentTab == 4) {
        if (index == 0) {
          this.$router.replace("/cosys/statisticsManage");
        }
      } else if (this.currentTab == 5) {
        if (index == 0) {
          this.$router.replace("/cosys/monitorUserStat");
        } else if (index == 1) {
          this.$router.replace("/cosys/monitorObjectStat");
        } else if (index == 2) {
          this.$router.replace("/cosys/monitorProjectStat");
        } else if (index == 3) {
          this.$router.replace("/cosys/monitorTodoStat");
        } else if (index == 4) {
          this.$router.replace("/cosys/monitorCoworkUseStat");
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/AuditSubTab.vue